import Client from "./Client";
// import RequestList from "./RequestList";

const Service = {
    url: 'admin/resellers',
    getDefault(){
        return {
            id : undefined,
            name : undefined,
            commission : undefined,
            settlement_period : undefined,
            minimum_amount_settlement : undefined,
            iban_number : undefined,
            iban_full_name : undefined,
            created_at : undefined,
            updated_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async update(model) {
        return await Client.post(`${this.url}/${model.id}`, model);
    }
}

export default Service